import { Navbar } from "../components/Navbar";
import { Reviews } from "../components/Reviews";
import { Footer } from "../components/Footer";

export default function ReviewsPage() {
  return (
    <main className="pt-16" data-testid="reviews-page">
      <Navbar />
      <Reviews />
      <Footer />
    </main>
  );
}
